import React from "react";
import { AOSProps } from "../../global/types";
import { Headline } from "../Headline/Headline";

interface ContentBoxProps extends AOSProps {
  headline?: string;
  Icon?: React.FC;
}

export const ContentBox: React.FC<ContentBoxProps> = ({
  children,
  headline,
  Icon,
  dataAos,
  dataAosDelay
}) => {
  return (
    <div
      className="content-box"
      data-aos={dataAos}
      data-aos-delay={dataAosDelay}
    >
      {Icon && (
        <div className="content-box__icon">
          <Icon />
        </div>
      )}
      <div className="content-box__content">
        {headline && (
          <Headline
            className="content-box__headline"
            level="h2"
            bold={headline}
          />
        )}
        {children}
      </div>
    </div>
  );
};
